import React from "react";

export const LogoIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="31"
        viewBox="0 0 26 31"
        fill="none">
        <g clip-path="url(#clip0_455_1195)">
          <path
            d="M6.69124 0H26V13.474H13.235V17.5241H26V30.9981H0V6.81587C0 3.0493 2.99908 0 6.69124 0Z"
            fill="white"
          />
          <path d="M0 17.5241L0 31H13.2295V17.5241H0Z" fill="#0042C2" />
        </g>
        <defs>
          <clipPath id="clip0_455_1195">
            <rect width="26" height="31" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
